module.exports = __webpack_public_path__ + "img/zx-nav-act.03119a73.png";